import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

export default class ImgEditing extends Plugin {
  init() {
    const editor = this.editor;
    const schema = editor.model.schema;

    schema.register( 'img', {
      allowWhere: ['$text', '$block'],
      allowAttributesOf: '$text',
      allowContentOf: '$root',
      isInline: true,
      isObject: true,
      allowAttributes: ['resource', 'src', 'alt', 'typeof', 'class', 'data-node-name', 'id', 'height', 'width', 'data-tenant-id', 'rel', 'loading', 'decoding']
    } );

    editor.conversion.for('upcast').elementToElement({
      view: 'img',
      model: (viewElement, { writer: modelWriter }) => {
        try {
          if(viewElement._children.length > 1 && viewElement._children[0]._textData.trim() === ''){
            viewElement._children[0]._remove();
          }
          return modelWriter.createElement('img', viewElement.getAttributes());
        } catch (error) {
          console.error('Error processing img element:', error);
          throw Error(error);
        }
      }
    });

    editor.conversion.for( 'downcast' ).elementToElement( {
      model: 'img',
      view: 'img'
    } );
  }
}